import { WORKTYPEGROUPLIST_SEARCH, WORKTYPEGROUPLIST_PAGE } from '../actions/worktypegrouplistactions';

const state = { search:'', page:0 };

const getters = {
    page: state => state.page,
    search: state => state.search
};

const actions = {
    [WORKTYPEGROUPLIST_SEARCH]: ({ commit }, search) => {
        commit(WORKTYPEGROUPLIST_SEARCH, search);
    },
    [WORKTYPEGROUPLIST_PAGE]: ({ commit }, page) => {
        commit(WORKTYPEGROUPLIST_PAGE, page);
    }
};

const mutations = {
    [WORKTYPEGROUPLIST_SEARCH]: (state, search) => {
        state.page = 0;
        state.search = search;
    },
    [WORKTYPEGROUPLIST_PAGE]: (state, page) => {
        state.page = page;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};